export default __webpack_public_path__ + "static/media/1.7c408e14.svg";